<template>
    <div class="navbar">
        <div class="logo-title">
            <a href="http://www.cebpubservice.com/" target="_blank"><img src="@/assets/images/home/books-logo.png" alt="logo" class="logo" /></a>
            <!-- <span class="title">中国招标投标公共服务平台</span> -->
        </div>
        <div class="login-btn">
            <span v-if="token && $route.path.startsWith('/person')" class="back-home" @click="goHome">
                返回首页
            </span>
            <el-popover placement="bottom" width="220" trigger="hover" v-if="token">
                <div style="text-align:center;padding:12px 0 12px 0;">
                    <div style="font-size:16px;margin-bottom:10px;color: #000;">{{ tel }}</div>
                    <el-button type="info" style="width:160px;height:40px;font-size:16px;border-radius:10px;"
                        @click="logout">退出登录</el-button>
                </div>
                <span slot="reference" style="cursor:pointer;display:flex;align-items:center;" @click="goPersonInfo">
                    <span class="icon-user" style="width:22px;height:22px;"></span>
                    <span style="font-weight:bold;font-size:16px;margin-left:6px;">
                        {{ tel.replace(/^(\d{3})\d{4}(\d{3})$/, '$1****$2') }}
                    </span>
                </span>
            </el-popover>
            <button v-else @click="openLogin">
                <span class="icon-user"></span>
                <span v-if="!token">去登录</span>
                <span v-else>{{ tel }}</span>
            </button>
        </div>
        <div class="detail-login" v-if="showLogin">
            <div class="login-modal">
                <!-- <div class="login-close">
                    <div class="login-close-bg"><img src="./images/logo.png" alt=""></div>
                    <img src="./images/close.png" class="close-icon" @click="closeLogin">
                </div> -->
                <div class="login-header">
                    <span class="login-title">中国招标投标公共服务平台</span>
                    <span class="login-close" @click="closeLogin"></span>
                </div>
                <div class="login-body">
                    <!-- 手机号输入 -->
                    <div class="input-group">
                        <input type="tel" placeholder="手机号码" v-model="loginForm.phone" @input="clearError('phone')"
                            :class="{ 'error': errors.phone }" maxlength="11">
                        <div class="error-tip" v-if="errors.phone">{{ errors.phone }}</div>
                    </div>
                    <!-- 图形验证码 -->
                    <div class="input-group">
                        <div class="input-flex">
                            <input type="text" placeholder="输入图形验证码" v-model="loginForm.captcha"
                                @input="clearError('captcha')" :class="{ 'error': errors.captcha }">
                            <img :src="captchaImage" class="captcha-img" @click="refreshCaptcha">
                        </div>
                        <div class="error-tip" v-if="errors.captcha">{{ errors.captcha }}</div>
                    </div>
                    <!-- 短信验证码 -->
                    <div class="input-group">
                        <div class="input-flex">
                            <input type="text" maxlength="6" placeholder="输入手机验证码" v-model="loginForm.smsCode"
                                @input="clearError('smsCode')" :class="{ 'error': errors.smsCode }" style="width: 67%;">
                            <button class="sms-btn" :class="{ disabled: smsCountdown != 60 }"
                                @click.prevent="sendSmsCode">
                                {{ smsButtonText }}
                            </button>
                        </div>
                        <div class="error-tip" v-if="errors.smsCode">{{ errors.smsCode }}</div>
                    </div>
                    <!-- 协议勾选 -->
                    <div class="protocol-group">
                        <label class="checkbox-label">
                            <input type="checkbox" v-model="loginForm.agreed">
                            <span class="checkmark"></span>
                            我已阅读并同意 <a href="./privacy.html" target="_blank">《隐私协议》</a>与<a href="./registration.html"
                                target="_blank">《注册协议》</a>
                        </label>
                        <div class="error-tip" v-if="errors.agreed">{{ errors.agreed }}</div>
                    </div>
                    <button class="submit-btn" @click.prevent="handleLogin">登录</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { captchaImg, sendCode, login } from '@/api/api.js'
import Cookies from 'js-cookie'
import { ElPopover, ElButton } from 'element-ui'
export default {
    name: 'navbar',
    props: {
        isHiddenlogin: {
            type: Boolean,
        }
    },
    data() {
        return {
            showLogin: false,
            loginForm: {
                phone: '',
                captcha: '',
                smsCode: '',
                agreed: false
            },
            captchaImage: '',
            smsCountdown: 60,
            intervalId: null,
            errors: {
                phone: '',
                captcha: '',
                smsCode: '',
                agreed: ''
            },
            smsButtonText: '发送短信验证码',
            uuid: null,
            token: Cookies.get('Authorization') || '',
            tel: Cookies.get('tel') || '',
        }
    },
    watch: {
        showLogin(val) {
            if (val) {
                this.refreshCaptcha()
                this.token = Cookies.get('Authorization') || '';
                this.tel = Cookies.get('tel') || '';
            }
        }
    },
    methods: {
        openLogin() {
            if (!this.token) {
                this.showLogin = true;
            }
        },
        closeLogin() {
            this.$emit('update:showLogin', false)
        },
        clearError(field) {
            this.errors[field] = ''
        },
        refreshCaptcha() {
            captchaImg().then((res) => {
                this.captchaImage = res.data.image;
                this.uuid = res.data.uuid;
            })
        },
        async sendSmsCode() {
            if (!this.loginForm.phone) {
                this.errors.phone = '请输入手机号码';
                return;
            } else if (!/^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
                this.errors.phone = '手机号码格式不正确';
                return;
            } else if (!this.loginForm.captcha) {
                this.errors.captcha = '请填写图像验证码！';
                return;
            }
            if (this.smsCountdown !== 60) return;
            this.startCountdown();
            try {
                sendCode({
                    phoneNumber: this.loginForm.phone,
                    code: this.loginForm.captcha,
                    uuid: this.uuid
                }).then((response) => {
                    if (response.code !== 200) {
                        this.resetCountdown();
                        this.refreshCaptcha();
                        this.loginForm.captcha = '';
                    }
                })
            } catch (error) {
                this.resetCountdown();
            }
        },
        startCountdown() {
            this.smsCountdown = 60;
            this.smsButtonText = `${this.smsCountdown}s后重新发送`;
            this.intervalId = setInterval(() => {
                this.smsCountdown--;
                this.smsButtonText = `${this.smsCountdown}s后重新发送`;
                if (this.smsCountdown <= 0) {
                    this.resetCountdown();
                }
            }, 1000);
        },
        resetCountdown() {
            clearInterval(this.intervalId);
            this.smsCountdown = 60;
            this.smsButtonText = '发送短信验证码';
        },
        closeLogin() {
            this.showLogin = false;
            this.loginForm = {
                phone: '',
                captcha: '',
                smsCode: '',
                agreed: false
            }
        },
        async handleLogin() {
            if (!this.validateForm()) return
            try {
                login({
                    "phoneNumber": this.loginForm.phone,
                    "smsCode": this.loginForm.smsCode,
                }).then((res) => {
                    if (res.code == 200) {
                        Cookies.set('tel', this.loginForm.phone)
                        Cookies.set('Authorization', res.data.token)
                        this.token = res.data.token;
                        this.tel = this.loginForm.phone;
                        this.showLogin = false;
                        this.$message.success('登录成功！')
                        // location.reload()
                    } else {
                        this.$message.error(res.msg || '登录失败')
                    }
                })
            } catch (error) {
                this.$message.error('登录失败')
                this.refreshCaptcha()
            }
        },
        validateForm() {
            let isValid = true
            this.errors = { phone: '', captcha: '', smsCode: '', agreed: '' }
            if (!this.loginForm.phone) {
                this.errors.phone = '请输入手机号码'
                isValid = false
            } else if (!/^1[3-9]\d{9}$/.test(this.loginForm.phone)) {
                this.errors.phone = '手机号码格式不正确'
                isValid = false
            }
            if (!this.loginForm.captcha) {
                this.errors.captcha = '请输入图形验证码'
                isValid = false
            }
            if (!this.loginForm.smsCode) {
                this.errors.smsCode = '请输入短信验证码'
                isValid = false
            } else if (!/^\d{6}$/.test(this.loginForm.smsCode)) {
                this.errors.smsCode = '验证码格式不正确'
                isValid = false
            }
            if (!this.loginForm.agreed) {
                this.errors.agreed = '请阅读并同意协议'
                isValid = false
            }
            return isValid
        },
        goPersonInfo() {
            this.$router.push('/person/info')
        },
        goHome() {
            this.$router.push('/')
        },
        logout() {
            Cookies.remove('Authorization')
            Cookies.remove('tel')
            this.token = ''
            this.tel = ''
            location.reload() // 或 this.$router.replace('/') 跳回首页
        },
    },
    mounted() {
    },
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.navbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    /* background: #f8f8f8; */
    /* padding: 16px 32px; */
    width: calc(var(--main-width) - 64px);
    padding: 16px 32px 0px 32px;
    margin: 0 auto;
}

.logo-title {
    display: flex;
    align-items: center;
}

.logo {
    width: 380px;
    margin-right: 12px;
}

.title {
    font-size: 26px;
    font-weight: bold;
    color: #183a6a;
}

.login-btn {
    display: flex;
}

.back-home {
    cursor: pointer;
    font-size: 16px;
    margin-right: 20px;
}

.login-btn button {
    border: none;
    border-radius: 50%;
    height: 48px;
    font-size: 16px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background: none;
}

.icon-user {
    display: inline-block;
    width: 26px;
    height: 26px;
    background: url('@/assets/images/home/user-icon.svg') no-repeat center/cover;
    margin-right: 8px;
}

.detail-login {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    position: fixed;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    border-radius: 5px;
    z-index: 99999;
}

/* 优化后的样式 */
.login-modal {
    width: 440px;
    background: #FFFFFF;
    border-radius: 8px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.login-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #2865D4;
    height: 45px;
    line-height: 45px;
}

.login-title {
    font-size: 18px;
    color: #fff;
    font-weight: 500;
    width: 100%;
    text-align: center;
    background-image: url('@/assets/images/home/logo.png');
    background-repeat: no-repeat;
    background-size: 45px;
    background-position: 60px center;
    padding-left: 60px;
}

.login-close {
    width: 45px;
    height: 45px;
    background-image: url('@/assets/images/home/login-close.png');
    background-repeat: no-repeat;
    background-size: 20px;
    background-position: center;
    cursor: pointer;
}

.close-icon {
    width: 15px;
    height: 15px;
    cursor: pointer;
    position: absolute;
    top: 16px;
    right: 15px;
}

.login-body {
    padding: 10px 24px 24px 24px;
}

.input-group {
    margin-bottom: 10px;
    position: relative;
}

.input-group input {
    width: 100%;
    height: 40px;
    border: none;
    border-bottom: 1px solid #DCDFE6;
    padding: 0 4px;
    font-size: 14px;
}

.input-group input.error {
    border-color: #F56C6C;
}

.error-tip {
    color: #F56C6C;
    font-size: 12px;
    margin-top: 4px;
    padding-left: 4px;
}

.input-flex {
    display: flex;
}

.captcha-img {
    height: 40px;
    cursor: pointer;
    border-radius: 2px;
    align-self: flex-end;
}

.sms-btn {
    height: 32px;
    padding: 0 8px;
    background: #3C78F2;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 12px;
    cursor: pointer;
    align-self: flex-end;
}

.sms-btn.disabled {
    background: #C0C4CC;
    cursor: not-allowed;
}

.protocol-group {
    margin: 20px 0;
    font-size: 12px;
    color: #606266;
}

.checkbox-label {
    display: flex;
    align-items: center;
}

.checkbox-label a {
    color: #1676DD;
}

.checkbox-label input {
    margin-right: 8px;
}

.submit-btn {
    width: 70%;
    height: 40px;
    background: #3C78F2;
    color: white;
    border: none;
    border-radius: 4px;
    font-size: 14px;
    cursor: pointer;
    margin: 0 auto;
    display: block;
}

.submit-btn:hover {
    background: #3C78F2;
}

.login-close {
    position: relative;
}

.login-close-bg {
    height: 45px;
    width: 100%;
    background: rgba(0, 0, 0, .7);
    display: flex;
    align-items: center;
    justify-content: center;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
}

.login-close-bg img {
    width: 55%;
}

.loading-box .el-icon-loading {
    color: #fff;
}

.loading-box .el-icon-loading:before {
    font-size: 35px;
}

.loading-box .el-loading-text {
    color: #fff !important;
    font-size: 16px !important;
}
</style>
